const Background = () => import('views/bg/Background')
// 站点配置
const AdminStoreConfig = () => import('views/bg/site/AdminStoreConfig')
const AdminNotifyConfig = () => import('views/bg/site/AdminNotifyConfig')
const AdminCategory = () => import('views/bg/site/AdminCategory')
const AdminSiteConfig = () => import('views/bg/site/AdminSiteConfig')

export default {
  path: '/bg/site',
  redirect: '/bg',
  name: 'Site',
  title: '站点配置',
  icon: 'el-icon-setting',
  component: Background,
  meta: { needAuth: true, roles: ['tnb_admin'] },
  children: [
    {
      path: '/bg/site/store',
      name: 'AdminStoreConfig',
      title: '存储配置',
      icon: 'el-icon-setting',
      component: AdminStoreConfig,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/site/notify',
      name: 'AdminNotifyConfig',
      title: '通知配置',
      icon: 'el-icon-setting',
      component: AdminNotifyConfig,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/site/config',
      name: 'AdminSiteConfig',
      title: '站点配置',
      icon: 'el-icon-setting',
      component: AdminSiteConfig,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/site/category',
      name: 'AdminCategory',
      title: '站点分区',
      icon: 'el-icon-setting',
      component: AdminCategory,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    }
  ]
}
